/**
 * Form-version comparison (docs/04 §2).
 *
 * This lives in its own module rather than beside the validator on purpose.
 * `compareVersions` is a runtime utility — `@rasd/storage-dexie` calls it to
 * pick the newest cached definition — while everything else in
 * `./validate.ts` pulls in zod. Sharing a module would make zod statically
 * reachable from the storage adapter's import graph, which would pin ~100 kB
 * into the eager bundle of every host and defeat the `@rasd/core/schema` split
 * documented in docs/17 §2.5.
 */
/** Segment-wise numeric-aware compare; segments split on `.`, `-`, `_` (docs/04 §2). */
export function compareVersions(a, b) {
    const as = a.split(/[.\-_]/);
    const bs = b.split(/[.\-_]/);
    const len = Math.max(as.length, bs.length);
    for (let i = 0; i < len; i += 1) {
        const x = as[i];
        const y = bs[i];
        if (x === undefined)
            return -1;
        if (y === undefined)
            return 1;
        const nx = Number(x);
        const ny = Number(y);
        if (Number.isFinite(nx) && Number.isFinite(ny) && x !== '' && y !== '') {
            if (nx !== ny)
                return nx < ny ? -1 : 1;
            continue;
        }
        if (x !== y)
            return x < y ? -1 : 1;
    }
    return 0;
}
//# sourceMappingURL=version.js.map